import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Upload: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 10V15C2.5 15.9205 3.24619 16.6667 4.16667 16.6667H15.8333C16.7538 16.6667 17.5 15.9205 17.5 15V10"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
      />
      <rect
        x="9.16675"
        y="11.6667"
        width="8.33333"
        height="1.66667"
        rx="0.833333"
        transform="rotate(-90 9.16675 11.6667)"
        fill={color}
      />
      <path
        d="M6.66675 6.66669L10.0001 3.33335L13.3334 6.66669"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Upload;
